import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import api from '../services/api'

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,

      login: async (username, password) => {
        const response = await api.post('/auth/token/', { username, password })
        const { access, refresh } = response.data
        localStorage.setItem('access_token', access)
        localStorage.setItem('refresh_token', refresh)

        const userResponse = await api.get('/users/users/me/')
        set({
          user: userResponse.data,
          accessToken: access,
          refreshToken: refresh,
          isAuthenticated: true,
        })
        return userResponse.data
      },

      logout: () => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
        })
      },

      fetchUser: async () => {
        try {
          const response = await api.get('/users/users/me/')
          set({ user: response.data, isAuthenticated: true })
          return response.data
        } catch {
          get().logout()
          return null
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ user: state.user, isAuthenticated: state.isAuthenticated }),
    },
  ),
)

export default useAuthStore
